export const NoRefetchQueryOptions = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchOnMount: false,
  retry: false,
  staleTime: 24 * 60 * 60 * 1000,
}